module.exports = __webpack_public_path__ + "static/media/icon_bullseye.1d055b33.svg";